import type {FC} from 'react';

import {FooterDraft} from './draft';
import {FooterServer} from './server';

interface Props {
	isDraft: boolean;
}

export const Footer: FC<Props> = ({isDraft}) => {
	return isDraft ? <FooterDraft isDraft={isDraft} /> : <FooterServer isDraft={isDraft} />;
};
